package pl.decks.chartjs.radar.options.plugins

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption

data class TooltipOptions(
    val enabled: Boolean = true,
    val mode: String? = null,
    val intersect: Boolean? = null,
    val backgroundColor: ChartColor? = null,
    val titleColor: ChartColor? = null,
    val bodyColor: ChartColor? = null,
    val borderColor: ChartColor? = null,
    val borderWidth: Int? = null,
    val callbacks: TooltipCallbacks? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.enabled = enabled.asDynamic()
        if (mode != null) this.mode = mode.asDynamic()
        if (intersect != null) this.intersect = intersect.asDynamic()
        if (backgroundColor != null) this.backgroundColor = backgroundColor.toChartJs()
        if (titleColor != null) this.titleColor = titleColor.toChartJs()
        if (bodyColor != null) this.bodyColor = bodyColor.toChartJs()
        if (borderColor != null) this.borderColor = borderColor.toChartJs()
        if (borderWidth != null) this.borderWidth = borderWidth.asDynamic()
        if (callbacks != null) this.callbacks = callbacks.toChartJs()
    }
}
